module.exports = __webpack_public_path__ + "img/academic-icon.245b9a32.svg";